<template>
  <div class="stok" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>Stok Keluar</h2>

      <br />

      <div class="filter-bar">
        <div class="form-group">
          <label for="">Filter Tanggal</label>
          <date-range-picker v-model="dateRange" date>
            <template v-slot:input="picker">
              {{ moment(picker.startDate).format("DD MMM YYYY") }} -
              {{ moment(picker.endDate).format("DD MMM YYYY") }}
            </template>
          </date-range-picker>
        </div>
        <div class="form-group">
          <label for="">Bahan baku</label>
          <input
            type="text"
            v-model="filter.nama"
            @keyup.enter="loadData()"
            placeholder="Cari..."
          />
        </div>
        <div>
          <label for="">&nbsp;</label>
          <button type="button" class="btn btn-fill" @click="loadData()">
            Filter
          </button>
        </div>
        <div></div>
        <div>
          <label for="">&nbsp;</label>
          <button
            type="button"
            class="btn-outline"
            v-if="!showFilter"
            @click="exportExcel"
            :disabled="loadingExcel"
          >
            Export Excel
          </button>
        </div>
      </div>

      <div class="table-wrapper">
        <table class="table">
          <thead>
            <tr>
              <th>Tanggal</th>
              <th>Barang</th>
              <th>Jumlah</th>
              <th>Dari</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in data" :key="index">
              <td
                v-show="item.master"
                colspan="4"
                style="border-bottom: 0; border-top: 1px solid #ccc"
              >
                <b>{{
                  item.no_nota == "null" ? "Penyesuaian stok" : item.no_nota
                }}</b>
              </td>

              <td v-show="!item.master" class="no-border">
                {{ moment(item.tanggal).format("DD MMM YYYY") }}
              </td>
              <td v-show="!item.master" class="no-border">{{ item.nama }}</td>
              <td v-show="!item.master" class="no-border">
                {{ Math.abs(item.jumlah) | decimal }} {{ item.satuan }}
              </td>
              <td v-show="!item.master" class="no-border">
                <span v-show="item.id_penjualan">Penjualan</span>
                <span v-show="!item.id_penjualan" class="penyesuaian"
                  >Penyesuaian Stok</span
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import _ from "lodash";

import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import * as api from "../../api/Api";
import Search from "../icons/Search.vue";
import Close from "../icons/Close.vue";

export default {
  name: "BahanBaku",
  components: {
    Search,
    Close,
    DateRangePicker,
  },
  data() {
    return {
      loading: false,
      data: [],
      tmpData: [],
      showFilter: false,
      loadingExcel: false,
      dateRange: {
        startDate: moment().format("YYYY-MM-01"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      filter: {
        id_toko: this.$toko.id,
      },
    };
  },
  methods: {
    moment,
    loadData() {
      this.loading = true;

      this.filter.tgl_awal = moment(this.dateRange.startDate).format(
        "YYYY-MM-DD"
      );
      this.filter.tgl_akhir = moment(this.dateRange.endDate).format(
        "YYYY-MM-DD"
      );

      api
        .get("/v4/stok/keluar?" + this.$objectToQuery(this.filter))
        .then((r) => {
          this.loading = false;

          const perNota = _.groupBy(r.data, "no_nota");
          const data = [];

          Object.keys(perNota).forEach((item) => {
            data.push({
              master: true,
              no_nota: item,
            });

            perNota[item].forEach((detail) => {
              data.push(detail);
            });
          });

          this.data = data;
        })
        .catch((e) => {
          this.loading = false;
          this.$toast("Gagal mengambil data");
        });
    },
    filterData() {
      if (this.keyword) {
        this.data = this.data.filter((k) => {
          return k.nama.toLowerCase().includes(this.keyword);
        });
      } else {
        return (this.data = this.tmpData);
      }
    },
    exportExcel() {
      if (this.data.length <= 0) {
        this.$toast("Tidak ada data untuk didownload");
        return;
      }

      this.loadingExcel = true;
      api
        .get("/v1/bahan-baku/export-excel?id_toko=" + this.$toko.id)
        .then((r) => {
          this.loadingExcel = false;
          if (r.valid) {
            location.href = r.filename;
          }
        })
        .catch((e) => {
          this.loadingExcel = false;
        });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped lang="scss">
.stok {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }

  .filter-bar {
    display: grid;
    grid-template-columns: 240px 240px 140px 1fr 160px;
    grid-column-gap: 15px;
    button {
      margin-top: 5px;
    }
  }

  .table-wrapper {
    height: calc(100vh - 290px);

    td.no-border {
      border-bottom: 0 !important;
    }

    span {
      font-size: 12px;
      padding: 4px 8px;
      background-color: var(--green);
      color: #fff;
      border-radius: 4px;
      &.penyesuaian {
        background-color: #f77a00;
      }
    }
  }
}
</style>
<style>
.reportrange-text {
  height: 43px;
}
</style>


// WEBPACK FOOTER //
// src/components/stok/StokKeluar.vue